import { useCallback, useState } from 'react';

import { makeGenerateWhatsAppProtocolIdUseCase } from 'shared/domain/useCases';

export default function useWhatsappProtocolId() {
  const [whatsappProtocolId, setWhatsappProtocolId] = useState<string>(
    makeGenerateWhatsAppProtocolIdUseCase().execute(),
  );

  const generateNewProtocolId = useCallback(() => {
    // We need to wait before setting a new ID because the React render gets confused and uses two different IDs (gambi)
    setTimeout(() => {
      setWhatsappProtocolId(makeGenerateWhatsAppProtocolIdUseCase().execute());
    }, 2000);
  }, []);

  return { whatsappProtocolId, generateNewProtocolId };
}
